import { changeCgGlobalLangIcon, changeCgLogoDesktop, changeCgLogoMobile } from './logoChanger';
//import {changeCgGlobalLangIcon} from "cg-frontend-utilities/js/utils";

export const headerWithCareerBanner = () => {

  const darkGradientClass = 'dark-gradient';

  /**
   * Get the headerTopBarWrapper element. We will be changing the CSS variables for this
   * element by passing the attribute values. Default CSS variables are already defined
   * in the SCSS file. See header.scss
   * @type {HTMLElement}
   */
  const headerTopBarWrapper = document.querySelector('.header-topbar-wrapper') as HTMLElement;
  const subNavigationWrapper = document.querySelector('.sub-navigation') as HTMLElement; 

  /**
   *
   * @type {HTMLElement}
   */
  const headerMobile = document.querySelector('.header-mobile') as HTMLElement;


  /**
   * Make header-nav-position css variable
   * @param property
   */
  const makeCssVarNavPos = (property: string) => {
    if(headerTopBarWrapper){
      (headerTopBarWrapper).style.setProperty( '--header-nav-position', property);
    }
  };

  /**
   * Make header-nav-menu-text-color css variable
   * @param textColor
   */
  const makeCssVarMenuTextColor = (textColor:string) => {
    if(headerTopBarWrapper){
      headerTopBarWrapper.style.setProperty( '--header-nav-menu-text-color', textColor);
    }
    if(headerMobile){
      headerMobile.style.setProperty('--header-mobile-menu-text-color', textColor);
    }
  };

  /**
   * Make header-nav-menu-text-color css variable
   * @param textColor
   */
  const makeCssVarSubMenuTextColor = (textColor: string) => {
    if(subNavigationWrapper){
      subNavigationWrapper.style.setProperty( '--header-subnav-menu-text-color', textColor);
    }
  };

  /**
   * Add gradient classes to nav headers for both mobile, desktop.
   * @param classListToAdd
   */
  const addGradientClassesToNavHeaders = (classListToAdd: string[]) => {
    if(headerTopBarWrapper) {
      headerTopBarWrapper.classList.add(...classListToAdd);
    }
    if(headerMobile) {
      headerMobile.classList.add(...classListToAdd);
    }
  };

  /**
   * Add gradient classes to nav headers for both mobile, desktop.
   * @param classListToAdd
   */
  const addGradientClassesToSubnavHeaders = (classListToAdd: string[]) => {
    if(subNavigationWrapper) {
      subNavigationWrapper.classList.add(...classListToAdd);
    }
  };


  /**
   * Get the careerBanner element from the id
   * @type {HTMLElement}
   */
  const careerBannerEle = document.querySelector('#career-banner');

  /**
   * Get the attributes passed from the save function to the data attribute
   * @type {string}
   */
if(careerBannerEle){
  if(window.matchMedia("(min-width: 1200px)").matches){
    /**
     * Parse and get the career banner attributes.
     * @type {CareerBannerAttributesType}
      /**
       * If menu should overlays the banner then the nav menu should start as position relative
       */
      makeCssVarNavPos('relative');

      /**
       * Pass the NavMenuTextColor from attributes to set the appropriate color
       * for menu text color CSS variable.
       */

      makeCssVarMenuTextColor('white');
      makeCssVarSubMenuTextColor('white');

      /**
       * Add class to identify dark gradient
       */
      addGradientClassesToNavHeaders([darkGradientClass]);
      addGradientClassesToSubnavHeaders([darkGradientClass]);

      /**
       * Change logo to white
       */
      changeCgLogoDesktop('white');
      changeCgLogoMobile('white');
      changeCgGlobalLangIcon('white');

  } else {
    makeCssVarNavPos('relative');

    makeCssVarMenuTextColor('#15011D');
    makeCssVarSubMenuTextColor('#15011D');

    /**
     * Change logo to blue
     */
    changeCgLogoDesktop('blue');
    changeCgLogoMobile('blue');
    changeCgGlobalLangIcon('black');
  }}
};